module.exports = __webpack_public_path__ + "img/ios2.6e18cf92.png";